module.exports = __webpack_public_path__ + "img/District of Columbia.8920cca4.png";